<template>
  <div>
    <div id="three"></div>

    <div class="hin">
      <div id="hin"></div>
    </div>

    <img id="replay" src="./img/replay.png" alt="Replay">
  </div>
</template>

<script>
  import main from './main'
  export default {
    name: 'Stack',
    mounted () {
      main.init()
    }
  }
</script>

<style scoped>
  #three{
    width: 100%;
    height: 100%;
    margin: 0;
  }

  .hin {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    transition: transform 0.5s 4s;
    user-select: none;
  }

  .hin #hin {
    color: cadetblue;
    font-size: 3.5rem;
    font-family: 'Exo', sans-serif;
    font-weight: 700;
  }

  #replay{
    position: absolute;
    top: 48%;
    left: 50%;
    width: 5rem;
    transform: translate(-50%, -50%);
    display: none;
    user-select: none;
    cursor: pointer;
  }

  #replay.show{
    display: unset;
  }

  @media only screen and (max-width: 1000px){
    .hin #hin {
      font-size: 2.5rem;
    }
    #replay{
      width: 3.5rem;
    }
  }

  @media only screen and (max-width: 800px) {
    .hin #hin {
      font-size: 1.7rem;
    }
  }
</style>
